import * as React from 'react';
import { type ISummaryAdditionalData } from './summaryAdditionalData.ts';

/**
 * Context con i dati aggiuntivi del riepilogo (`dati-aggiuntivi-riepilogo`).
 *
 * Il riepilogo è condiviso tra Frontoffice e Backoffice, ma solo il
 * Backoffice consuma l'endpoint: è la sola app che monta il provider. In
 * assenza di provider il context è `null` e i consumer si comportano come
 * prima dell'introduzione dell'endpoint — nessun responsabile, nessuna
 * competenza risolta dal BE, nessuna azione di visualizzazione JSON.
 *
 * Il `null` copre anche il caso in cui la chiamata fallisca: i dati sono
 * additivi e il riepilogo deve restare utilizzabile senza di essi.
 */
export const SummaryAdditionalDataContext =
  React.createContext<ISummaryAdditionalData | null>(null);

export const useSummaryAdditionalData = () =>
  React.useContext(SummaryAdditionalDataContext);

export function SummaryAdditionalDataProvider(
  props: React.PropsWithChildren<{ data: ISummaryAdditionalData | null }>,
) {
  const { data, children } = props;
  return (
    <SummaryAdditionalDataContext.Provider value={data}>
      {children}
    </SummaryAdditionalDataContext.Provider>
  );
}
